import React from 'react';
import { connect } from 'react-redux';
import RecentPaymentsHeader from '../../components/RecentPayments/Components/RecentPaymentsHeader';
import RecentPaymentsWrapper from '../../components/RecentPayments/Components/RecentPaymentsWrapper';
import { getRecentPaymentsRequest } from '../../components/RecentPayments/Redux/actions';
import { PARTNERS_WITH_RECENT_PAYMENTS } from '../../routes/PartnersEnum';
import { getPartnerGuid } from '../../lib/access.es6';
import PageNotFound from '../PageNotFound/index.es6';

class RecentPaymentsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      size: 20,
    }
  }

  componentWillMount() {
    const partnerGuid = getPartnerGuid();
    
    // Check if the current partner has access to Recent Payments
    if (!PARTNERS_WITH_RECENT_PAYMENTS.includes(partnerGuid)) {
      return;
    }

    // Load past 30 days of payments by default (all statuses)
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);
    
    const payload = {
      page: 1,
      size: 20,
      from_date: thirtyDaysAgo.toISOString().split('T')[0] + 'T00:00:00.000Z',
      to_date: today.toISOString().split('T')[0] + 'T23:59:59.999Z'
      // No status filter - shows all payment statuses
    };

    this.props.dispatch(getRecentPaymentsRequest(payload));
  }

  getPayments = (payload = {}) => {
    const page = payload.page || 1;
    const size = payload.size || 20;
    
    // Always use past 30 days date range
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);
    
    const requestPayload = {
      page,
      size,
      from_date: thirtyDaysAgo.toISOString().split('T')[0] + 'T00:00:00.000Z',
      to_date: today.toISOString().split('T')[0] + 'T23:59:59.999Z'
      // No status filter - shows all payment statuses
    };

    this.props.dispatch(getRecentPaymentsRequest(requestPayload));
  }

  render() {
    const partnerGuid = getPartnerGuid();
    
    // Check if the current partner has access to Recent Payments
    if (!PARTNERS_WITH_RECENT_PAYMENTS.includes(partnerGuid)) {
      return <PageNotFound />;
    }

    const { recentPaymentsData } = this.props;
    const { payments = [], loader = false, page = 1, size = 20, total = 0 } = recentPaymentsData || {};

    return (
      <>
        <RecentPaymentsHeader
          title="Recent Payments"
        />
        
        <RecentPaymentsWrapper
          getPayments={this.getPayments}
          payments={payments}
          loader={loader}
          page={page}
          size={size}
          total={total}
        />
      </>
    );
  }
}

export default connect((state) => ({
  recentPaymentsData: state.recentPaymentsData
}))(RecentPaymentsContainer);